<template>
  <b-form-checkbox
    ref="field"
    switch
    :checked="innerValue"
    :disabled="disabled"
    :readonly="readonly"
    :required="required"
    size="lg"
    class="b-custom-switch pl-0"
    @input.native="onInput($event)"
  >
    <div class="custom-switch-label">
      {{ calcLabel }}
    </div>

    <div class="switch-outer">
      <div class="switch-inner" />
    </div>
  </b-form-checkbox>
</template>

<script>
export default {
  name: 'BCustomSwitch',

  props: ['value', 'label', 'required', 'readonly', 'disabled'],

  data() {
    return {
      innerValue: null,
    };
  },

  computed: {
    calcLabel() {
      return `${this.label}${this.required ? ' *' : ''}`;
    },
  },

  watch: {
    value: {
      immediate: true,
      handler(nextValue) {
        this.innerValue = nextValue;
      },
    },
  },

  methods: {
    onInput(event) {
      this.innerValue = event.target.checked;
      this.$emit('input', this.innerValue);
    },
  },
};
</script>

<style>
.b-custom-switch {
  position: relative;
  display: flex;
  flex-direction: row-reverse;
  justify-content: flex-end;
  align-items: center;
  margin-top: 8px;
  margin-bottom: 8px;
}

.b-custom-switch .custom-switch-label {
  flex-grow: 1;
  padding-right: 3mm;
}

.b-custom-switch > input {
  /* visibility: hidden; */
  display: none;
}

.b-custom-switch .custom-control-label {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  flex-grow: 1;
}

.b-custom-switch .custom-control-label .switch-outer {
  width: 1.75em;
  height: 1em;
  border-radius: 0.5em;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  pointer-events: none;
  background-color: #fff;
  border: 1px solid #adb5bd;
  display: flex;
  flex-direction: row;
  align-items: center;
}

.b-custom-switch .custom-control-label .switch-inner {
  width: calc(1em - 4px);
  height: calc(1em - 4px);
  background-color: #adb5bd;
  border-radius: 0.5em;
  pointer-events: all;
  transform: translateX(0.05em);
  transition: transform 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out,
    box-shadow 0.15s ease-in-out;
}

.b-custom-switch .custom-control-input:checked ~ .custom-control-label .switch-inner {
  background-color: #ffffff;
  transform: translateX(0.75em);
}

.b-custom-switch .custom-control-input:disabled:checked ~ .custom-control-label .switch-outer {
  border-color: rgba(0, 123, 255, 0.5);
  background-color: rgba(0, 123, 255, 0.5);
}

.b-custom-switch .custom-control-input:checked ~ .custom-control-label .switch-outer {
  color: #ffffff;
  border-color: #007bff;
  background-color: #007bff;
}

@media (prefers-reduced-motion: reduce) {
  .b-custom-switch .custom-control-label .switch-inner {
    transition: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/organisation/BCustomSwitch.vue